import connectEmojiQueue from '../../connectEmojiQueue.js';
import DisplayEmojiComponent from './DisplayEmoji.jsx';

const DisplayEmoji = connectEmojiQueue(DisplayEmojiComponent);

export default DisplayEmoji;

export {
  DisplayEmojiComponent,
}
